import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useOutletContext } from 'react-router'

import { PageLevelTableWrapper } from '@base'
import { Table as TableV2, useTableReducer } from '@baseV2'
import { DRAWER_TYPES, strings } from '@constants'
import { getAllDispatchPlanCards } from '@data'
import { toggleDrawer } from '@data/state/action/root'

import { getDispatchPlanCardColumns } from '../dispatchPlanCardColumns'

const DispatchPlanList = () => {
	const dispatch = useDispatch()
	const [state, tableDispatch, actions] = useTableReducer()
	const { forceUpdate, update } = useOutletContext()
	const userId = useSelector((_state) => _state.getIn(['user', 'user', 'user_id']))

	useEffect(() => {
		if (state.loading) {
			return
		}
		tableDispatch(actions.fetchTableDataProgress())
		getAllDispatchPlanCards(userId, state.query.page, 10, { ...state.query.filters, statusFilter: 'ACTIVE' })
			.then((response) => {
				tableDispatch(actions.fetchTableDataSuccess(response.data, response.count))
			})
			.catch((error) => tableDispatch(actions.fetchTableDataFailure(error)))
	}, [state.query, forceUpdate])

	const columns = useMemo(() => getDispatchPlanCardColumns(), [])

	const rowClickHandler = (data) => {
		dispatch(
			toggleDrawer(true, DRAWER_TYPES.DISPATCH_PLANS_BY_SPO, {
				label: strings('dispatch_plans_by_spo'),
				orderId: data?.order_id,
				poNumber: data?.original_supplier_po_number,
				update: update,
			})
		)
	}

	const onPageChangeHandler = (next = true) => {
		tableDispatch(actions.changePage(next))
	}

	return (
		<PageLevelTableWrapper>
			<TableV2
				data={state.data}
				columns={columns}
				loading={state.loading}
				rowsToDisplay={10}
				page={state.query.page}
				totalItemCount={state.total_count}
				onPageChange={onPageChangeHandler}
				onRowClick={rowClickHandler}
				fullHeight
			/>
		</PageLevelTableWrapper>
	)
}

export default DispatchPlanList
